.description {
    font-size: var(--font-normal);
    line-height: 1.4;
    color: var(--grey-lt);
    padding-bottom: 16px;
    border-bottom: 1px solid var(--off-white-dk);
}
